var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.173,
    height: 30,
    viewBox: "0 0 23.173 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-text",
    transform: "translate(-3 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M17.233,2H6.647A2.727,2.727,0,0,0,4,4.8V27.2A2.727,2.727,0,0,0,6.647,30h15.88a2.727,2.727,0,0,0,2.647-2.8V10.4Z",
    fill: "none",
    stroke: "#de4a25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M14,2v8.4h7.94",
    transform: "translate(3.233)",
    fill: "none",
    stroke: "#de4a25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_381",
    "data-name": "Line 381",
    x1: 11.592,
    transform: "translate(8.791 17.226)",
    fill: "none",
    stroke: "#de4a25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_382",
    "data-name": "Line 382",
    x1: 11.592,
    transform: "translate(8.791 23.358)",
    fill: "none",
    stroke: "#de4a25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M10.647,9H8",
    transform: "translate(1.293 2.8)",
    fill: "none",
    stroke: "#de4a25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.d9e881e3f7331d03b28f0cf6d9401d04.svg";
export { ForwardRef as ReactComponent };